import React from "react"

export default function BackendIcon() {
  return (
    <svg
      width="50"
      height="54"
      viewBox="0 0 50 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="white-fill"
        d="M1.02569 8.83639C1.74361 4.45585 11.9972 0.981812 24.5454 0.981812V53.0182C11.9973 53.0182 1.74372 49.5439 1.02569 45.1636H0.981812V8.83639H1.02569Z"
        fill="#4996FF"
      />
      <path
        d="M48.0652 8.83639C47.3472 4.45585 37.0937 0.981812 24.5454 0.981812V53.0182C37.0936 53.0182 47.3471 49.5439 48.0652 45.1636H48.109V8.83639H48.0652Z"
        fill="#B9D7FF"
      />
      <path
        className="white-fill"
        d="M45.1199 8.83639C44.402 4.45585 40.0392 0.981812 27.491 0.981812C14.9427 0.981812 4.68917 4.45585 3.97124 8.83639H3.92737V45.1636H3.97124C4.68927 49.5439 14.9428 53.0182 27.491 53.0182C40.0391 53.0182 44.4018 49.5439 45.1199 45.1636H45.1637V8.83639H45.1199Z"
        fill="#4996FF"
      />
      <path
        d="M27 18.6546C39.2005 18.6546 49.091 14.6984 49.091 9.8182C49.091 4.938 39.2005 0.981812 27 0.981812C14.7995 0.981812 4.90906 4.938 4.90906 9.8182C4.90906 14.6984 14.7995 18.6546 27 18.6546Z"
        fill="#4996FF"
      />
      <path
        d="M23.0726 18.6546C35.2731 18.6546 45.1636 14.6984 45.1636 9.8182C45.1636 4.938 35.2731 0.981812 23.0726 0.981812C10.8721 0.981812 0.981689 4.938 0.981689 9.8182C0.981689 14.6984 10.8721 18.6546 23.0726 18.6546Z"
        fill="#4996FF"
      />
      <path
        d="M24.5454 19C37.248 19 47.5454 14.9706 47.5454 10C47.5454 5.02944 37.248 1 24.5454 1C11.8429 1 1.54541 5.02944 1.54541 10C1.54541 14.9706 11.8429 19 24.5454 19Z"
        fill="#B9D7FF"
      />
      <path
        className="blue-fill"
        d="M24.5454 54C11.6485 54 1.27428 50.4122 0.11507 45.6066C0.0400812 45.471 0.000425008 45.3186 3.1332e-06 45.1636V8.83638C-0.000418742 8.66995 0.0417687 8.50627 0.122769 8.36082C1.31931 3.57254 11.6763 0 24.5454 0C37.4145 0 47.7715 3.57254 48.9682 8.36082C49.0491 8.50627 49.0914 8.66995 49.091 8.83638V45.1636C49.0914 45.33 49.0492 45.4937 48.9682 45.6392C47.7706 50.4275 37.4136 54 24.5454 54ZM1.96362 44.876C1.97723 44.918 1.98777 44.961 1.99526 45.0045C2.5514 48.4006 11.7464 52.0364 24.5454 52.0364C37.3445 52.0364 46.5395 48.4006 47.0956 45.0045C47.1032 44.9597 47.1137 44.9155 47.1272 44.8721V9.124C47.1136 9.0816 47.1031 9.03835 47.0956 8.99459C46.5404 5.59944 37.3465 1.96362 24.5454 1.96362C11.7444 1.96362 2.55045 5.59944 1.99526 8.99459C1.98777 9.03973 1.97723 9.08423 1.96362 9.1279V44.876Z"
        fill="white"
      />
      <path
        className="blue-fill"
        d="M24.5454 44.1818C11.6485 44.1818 1.27427 40.5939 0.115066 35.7884C0.0400781 35.6527 0.000421875 35.5004 0 35.3454V22.5818C0 22.0396 0.439594 21.6 0.981809 21.6C1.52402 21.6 1.96362 22.0396 1.96362 22.5818C1.96362 26.2895 11.6208 30.4364 24.5454 30.4364C37.4701 30.4364 47.1272 26.2895 47.1272 22.5818C47.1272 22.0396 47.5668 21.6 48.109 21.6C48.6513 21.6 49.0908 22.0396 49.0908 22.5818V35.3454C49.0913 35.5118 49.0491 35.6755 48.9681 35.821C47.7706 40.6092 37.4136 44.1818 24.5454 44.1818ZM1.96362 35.0578C1.97722 35.0998 1.98777 35.1428 1.99526 35.1862C2.55139 38.5823 11.7464 42.2182 24.5454 42.2182C37.3445 42.2182 46.5395 38.5823 47.0956 35.1862C47.1032 35.1415 47.1137 35.0972 47.1272 35.0539V26.4295C43.3783 29.9358 34.6676 32.4 24.5454 32.4C14.4233 32.4 5.7125 29.9358 1.96362 26.4295V35.0578Z"
        fill="white"
      />
      <path
        className="blue-fill"
        d="M24.5454 32.3999C11.6485 32.3999 1.27427 28.8121 0.115066 24.0065C0.0400781 23.8709 0.000421875 23.7186 0 23.5635V10.7999C0 10.2577 0.439594 9.81812 0.981809 9.81812C1.52402 9.81812 1.96362 10.2577 1.96362 10.7999C1.96362 14.5077 11.6208 18.6545 24.5454 18.6545C37.4701 18.6545 47.1272 14.5077 47.1272 10.7999C47.1272 10.2577 47.5668 9.81812 48.109 9.81812C48.6513 9.81812 49.0908 10.2577 49.0908 10.7999V23.5635C49.0913 23.73 49.0491 23.8937 48.9681 24.0391C47.7706 28.8274 37.4136 32.3999 24.5454 32.3999ZM1.96362 23.2759C1.97722 23.3179 1.98777 23.3609 1.99526 23.4044C2.55139 26.8005 11.7464 30.4363 24.5454 30.4363C37.3445 30.4363 46.5395 26.8005 47.0956 23.4044C47.1032 23.3597 47.1137 23.3154 47.1272 23.272V14.6476C43.3783 18.1539 34.6676 20.6181 24.5454 20.6181C14.4233 20.6181 5.7125 18.1539 1.96362 14.6476V23.2759Z"
        fill="white"
      />
    </svg>
  )
}
